<template>
  <a href="#" class="block block-link-shadow block-rounded block-bordered" @click.prevent="onClick">
    <div class="block-content block-content-full">
      <div class="py-5 text-center">
        <div class="mb-15">
          <i :class="[`fa fa-${icon} fa-3x text-muted`]"></i>
        </div>
        <div class="font-size-sm font-w600 text-uppercase text-muted">
          <img :src="require(`./shipping-provider-icons/postnl.png`)" class="shipping-provider-icon">
          <slot />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icon: String
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped>
.shipping-provider-icon {
  height: 16px;
  width: 16px;
  transform: translate(0, -1px);
}
</style>



// WEBPACK FOOTER //
// PostageStampType.vue?19ee1df2